/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_New_Create_BtnInputs */



/**
* | output |
* | --- |
* | "Create League" |
*
* @param {League_New_Create_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_new_create_btn = /** @type {((inputs?: League_New_Create_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_New_Create_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer la ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear Liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar Liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea Campionato")
	return /** @type {LocalizedString} */ ("Create League")
});